<script setup>
import ProductManagementTable from '@frontJs/components/tables/projectManagement/sea/ProductManagementTable.vue';
import TenantReportProductManagementTable from '@frontJs/components/tables/projectManagement/sea/tenantReports/ProductManagementTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Pilotage Shopping - SEA - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEA - Pilotage Shopping
    </PageTitle>

    <ProductManagementTable v-if="tenant" :tenant="tenant" />
    <TenantReportProductManagementTable v-else />
</template>
